/* eslint-disable eqeqeq */

import { useContext, useMemo, useState } from "react";
import { useForm } from "@mantine/form";

import {
  Alert,
  Group,
  Modal,
  Select,
  Space,
  Text,
} from "@mantine/core";

import { Button } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import { BaseResult, Fund, NotificationMSG } from "../types";
import { httpsCallable } from "firebase/functions";
import { useFunctions } from "../helpers/firebaseContext";
import { GlobalDataContext } from "../contexts";





type FormProps = {
  fund: string;
};

type FundSelectOption = {
  value: string;
  label: string;
};


const SendFundCertificate = (props: any) => {

  const opened: boolean = props.opened;
  const setOpened = props.setOpened;
  const [confirming, setConfirming] = useState<boolean>(false);
  const [msg, setMsg] = useState<NotificationMSG | null>(null);
  const globalDataContext = useContext(GlobalDataContext);

  const functions = useFunctions();
  functions.region = "europe-west1";
  const sendFundCertificate = httpsCallable<{
    fund: string;
  }, BaseResult>(functions, "sendFundCertificate");

  const fundOptions = useMemo<FundSelectOption[]>(() =>
    (globalDataContext.funds ?? [])
      .filter((fund: Fund & { active?: boolean }) =>
        fund.active === true
        && fund.certificates_ready === true
      )
      .map((fund) => ({
        value: fund.id || fund.code || "",
        label: [fund.name_en || fund.name, fund.name_ar].filter(Boolean).join(" - ") || fund.id,
      }))
      .filter((option) => Boolean(option.value))
      .sort((a, b) => a.label.localeCompare(b.label)),
    [globalDataContext.funds],
  );



  const handleSubmit = async (data: FormProps) => {
    if (data?.fund) {
      try {
        const result = await sendFundCertificate({
          fund: data.fund,
        });
        console.log("result from cloud function:", result);
        setMsg({ type: "success", message: "Fund certificates were queued for sending." });

      } catch (error) {
        console.log("error sending fund certificates:", error);
        setMsg({ type: "error", message: "Error sending fund certificates. Check console for details." });
        return;
      }


    } else {
      setMsg({ type: "error", message: "Fund not selected" });
    }

  }
  const form = useForm<FormProps>({

  });

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => {
          setMsg(null);
          setOpened(false);
          setConfirming(false)
        }}
        title="Send Fund Certificates"
      >

        <Text>
          This sends each clients their fund certificate through WhatsApp.
        </Text>

        <Space h="xl" />

        <form
          onSubmit={form.onSubmit(async (values) => {
            console.log(values);



            // setConfirmDialogError(null);
            setMsg(null);
            // props?.setPending(true)

            setConfirming(true);


            try {

              await handleSubmit(values)

              // setIsError(true);
              // setMsg({ type: "success", message: "Updating orders statuses to " });
            } catch (error: any) {
              // setIsError(true);
              console.log(error);
              // setMsg(error.message);
              // setMsg({type:"error",msg:});
              setMsg({ type: "error", message: error.message });


              // setConfirmDialogError(error.message);
            }

            setConfirming(false);

          })}
        >





          <Select
            {...form.getInputProps("fund")}
            label="Select fund"
            placeholder="Choose fund"
            data={fundOptions}
            searchable
            required
          />
          <Space h="xl" />




          <Group>
            <Button color="grape" type="submit" loading={confirming}>
              Send Fund Certificates
            </Button>
          </Group>

          <Space h="xl" />

          {msg && (
            <Alert
              icon={<IconAlertCircle size={16} />}
              color={msg.type == "success" ? "green" : msg.type == "info" ? "blue" : "red"}
              title={msg.type == "success" ? "Success" : msg.type == "info" ? "Info" : "Failure"}
            >


              {msg.message}
              <br />


            </Alert>
          )}

        </form>
      </Modal >
    </>
  );
}

export default SendFundCertificate;
